export default {
  PersonalInfoFormFields__ASSOCIATED_ADULT_LABEL: "Associated Adult",
};
